// extracted by mini-css-extract-plugin
export default {"spinner-overlay":"spinner-overlay--35U-G","spinner-overlay--fixed":"spinner-overlay--fixed--2mnVm","spinner-overlay--opaque":"spinner-overlay--opaque--2BoaA","spinner":"spinner--3apB2","spinner--small":"spinner--small--1NQv7","spinner__panel":"spinner__panel--7JXUn","spinner-bubble":"spinner-bubble--1Vcbv","spinner-bubble-small":"spinner-bubble-small--3ywNQ"};
    if(module.hot) {
      // 1747648136235
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  